import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormDecorationField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { TranslocoService } from '@ngneat/transloco';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { DialogsService } from '../../../../dialogs/dialogs.service';
import { FuseConfirmationService } from '../../../../../@fuse/services/confirmation/confirmation.service';

@Component({
    selector: 'icon-field-component',
    templateUrl: './icon-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeIconFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormDecorationField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    constructor(
        private dialogsService: DialogsService,
        private _fuseConfirmationService: FuseConfirmationService,
        private translocoService: TranslocoService
    ) { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

    openDialog() {
        const dialog = this.dialogsService.openIconPickerDialog(this.field.control.value, this.field.families);
        dialog.afterClosed().subscribe((result) => {
            if (result) {
                this.field.control.setValue(result);
            }
        });
    }

    async deleteIcon() {
        const confirmed = await this.confirm();
        if (confirmed) {
            this.field.control.setValue('');
        }
    }

    private confirm() {
        const dialogRef = this._fuseConfirmationService.open({
            title: this.translocoService.translate('warning'),
            message: this.translocoService.translate('removeIconConfirm'),
            actions: {
                confirm: {
                    label: this.translocoService.translate('accept')
                },
                cancel: {
                    label: this.translocoService.translate('cancel')
                }
            }
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe(result => resolve(result === 'confirmed'));
        });
    }

}
